import React from 'react';
import Modal from './modal';
import DriverForm from "../forms/driver";
import ResetForm from "../forms/reset-password";
import { connect } from 'react-redux';
import {
    resendInviteDriver,
    updateDriver,
    resetDriverPassword,
    changeDriverStatus,
    loadDrivers
} from '../../../../../redux/modules/vendors';
import LoadMask from '../../../Utils/LoadMask';
import DriverCard from './card';


const DriverList = (props) => {
    const {
        vendor_id,
        data = [],
        loading = false,
        driver_loading = false,
        loadDrivers,
        updateDriver,
        resetDriverPassword,
        resendInviteDriver,
        changeDriverStatus
    } = props;

    const [modalEdit, setModalEdit] = React.useState(false);
    const [modalReset, setModalReset] = React.useState(false);
    const [dataInvite, setDataInvite] = React.useState(null);
    const [modalInvite, setModalInvite] = React.useState(false);
    const [editData, setEditData] = React.useState(null);

    React.useEffect(() => {
        if (vendor_id)
            loadDrivers({ vendor_id })
    }, [vendor_id])

    const onOpenModalReset = (item) => {
        setEditData(item);
        setModalReset(true);
    }

    const onCloseModalReset = () => {
        setEditData(null);
        setModalReset(false);
    }

    const onSubmitModalReset = async (values) => {
        const response = await resetDriverPassword(values);
        if (response)
            onCloseModalReset()
    }

    const onOpenModalInvite = (item) => {
        setDataInvite(item);
        setModalInvite(true);
    }

    const onCloseModalInvite = () => {
        if(!driver_loading) {
            setDataInvite(null);
            setModalInvite(false);
        }
    }

    const onSubmitInvite = async () => {
        const response = await resendInviteDriver(dataInvite.id);
        if (response)
            onCloseModalInvite();
    }

    const onOpenModalEdit = (item) => {
        setEditData({
            id: item.id,
            first_name: item.user.first_name,
            last_name: item.user.last_name,
            email: item.user.email,
            role: item.role,
            user_type: item.user_type,
            mobile_phone: item.mobile_phone
        });
        setModalEdit(true);
    }

    const onCloseModalEdit = () => {
        if (!driver_loading) {
            setEditData(null);
            setModalEdit(false);
        }
    }

    const onSubmitEdit = async (values) => {
        const response = await updateDriver(editData.id, values)
        if (response){
            onCloseModalEdit();
        }
    }

    const onChangeDriverStatus = async (item) => {
        changeDriverStatus(item.id, !item.active)
    }

    if (!vendor_id)
        return (
            <div>
                <h5> No Vendor ID has been provided</h5>
            </div>
        )

    return (
        <LoadMask loading={loading} blur>
            <Modal open={modalEdit}
                onClose={onCloseModalEdit}
                closeOnOverlayClick={!driver_loading}
            >
                <Modal.Header title="Edit Driver"/>
                <div className="p-4">
                    <LoadMask loading={driver_loading} blur>
                        <DriverForm
                            showBtns={false}
                            id="driver-form"
                            onSubmit={onSubmitEdit}
                            showPasswordField={false}
                            initialValues={editData}
                        />
                    </LoadMask>
                </div>
                <Modal.Footer idForm="driver-form" />
            </Modal>
            <Modal open={modalReset}
                onClose={() => onCloseModalReset()}
                styles={{
                    modal: { borderRadius: 12, maxWidth: 500 }
                }}
            >
                <Modal.Header title="Reset Password"/>
                <div className="p-4">
                    <LoadMask loading={driver_loading} blur>
                        <ResetForm
                            showBtns={false}
                            id="modal-reset-pass"
                            onSubmit={onSubmitModalReset}
                            initialValues={modalReset ? {
                                username: editData && editData.user.username,
                            } : {}}
                        />
                    </LoadMask>
                </div>
                <Modal.Footer>
                    <div className="col-12 d-flex justify-content-end">
                        <button type="button"
                            className="btn btn-outline-secondary px-3 py-2 m-1"
                            onClick={onCloseModalReset}
                            disabled={driver_loading}
                        >
                            <span className="h6 mb-0 fw-600">
                                Cancel
                            </span>
                        </button>
                        <button type="submit"
                            form="modal-reset-pass"
                            className="btn btn-warning px-3 py-2 m-1"
                            disabled={driver_loading}
                        >
                            <i className="fa fa-key mr-1" />
                            <span className="h6 mb-0 fw-600">
                                Confirm Reset
                            </span>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal open={modalInvite}
                onClose={onCloseModalInvite}
                styles={{
                    modal: { borderRadius: 12, maxWidth: 340 }
                }}
            >
                <Modal.Header title="Resend Invite"/>
                <div className="p-4">
                    <div className="col-12 p-0">
                        <LoadMask loading={driver_loading} blur>
                            <div className="d-flex flex-column justify-content-center text-center">
                                <div
                                    className="h1 mb-3"
                                    style={{ color: "#ffc107" }}
                                >
                                    <i className="fa fa-envelope-o" />
                                </div>
                                <span className="h6 mb-4">
                                    Resend invite to:
                                </span>
                                <span className="h6 fw-600 mb-3">
                                    {dataInvite && dataInvite.user && dataInvite.user.email}
                                </span>
                                <span className="mb-4 text-muted"
                                    style={{ fontSize: "95%" }}
                                >
                                    This will generate a new temporary password and send a new invite email with app download instructions.
                                </span>
                            </div>
                        </LoadMask>
                    </div>
                </div>
                <Modal.Footer>
                    <div className="col-12 d-flex justify-content-center">
                        <button type="button"
                            className="btn btn-outline-secondary m-1"
                            onClick={onCloseModalInvite}
                            disabled={driver_loading}
                        >
                            <span className="fw-600">
                                Cancel
                            </span>
                        </button>
                        <button type="button" className="btn btn-primary m-1"
                            onClick={onSubmitInvite}
                            disabled={driver_loading}
                        >
                            <i className="fa fa-send mr-1" />
                            <span className="fw-600">
                                Send Invite
                            </span>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            {data.length == 0 ? (
                <div className="vendors__empty-state">
                    <div className="vendors__empty-icon">
                        <i className="fa fa-building-o"></i>
                    </div>
                    <div className="vendors__empty-text">No Drivers found</div>
                    <div className="vendors__empty-subtext">Try adjusting your search or filter criteria</div>
                </div>
            ) : (
                data.map((item, index) => (
                    <DriverCard
                        key={index}
                        item={item}
                        onOpenModalEdit={onOpenModalEdit}
                        onOpenModalInvite={onOpenModalInvite}
                        onOpenModalReset={onOpenModalReset}
                        onChangeDriverStatus={onChangeDriverStatus}
                    />
                ))
            )}
        </LoadMask>
    )
}

const mstp = (state) => ({
    loading: state.vendors.loading_list_drivers,
    data: state.vendors.drivers && state.vendors.drivers.results,
    driver_loading: state.vendors.driver_loading, 
});

const mdtp = {
    loadDrivers,
    updateDriver,
    resetDriverPassword,
    resendInviteDriver,
    changeDriverStatus,
}

export default connect(mstp, mdtp)(DriverList);
